/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_TextInputs */

const en_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like thumbnails generated for each detected shot change? This can take additional time.`)
};

const fr_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitez-vous que des vignettes soient générées pour chaque changement de plan détecté ? Cela peut prendre plus de temps.`)
};

const de_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie für jeden erkannten Einstellungswechsel ein Vorschaubild erstellen? Dies kann zusätzliche Zeit in Anspruch nehmen.`)
};

const it_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desideri che vengano generate delle miniature per ogni cambio di inquadratura rilevato? Questa operazione potrebbe richiedere del tempo aggiuntivo.`)
};

const ru_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотите, чтобы для каждого обнаруженного изменения ракурса генерировались миниатюры? Это может занять дополнительное время.`)
};

const es_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desea que se generen miniaturas para cada cambio de toma detectado? Esto puede llevar tiempo adicional.`)
};

const zh_cn2_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您是否希望为每次检测到的镜头变化生成缩略图？这可能会花费额外时间。`)
};

const ja_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検出されたショットの変化ごとにサムネイルを生成しますか？これには追加の時間がかかる場合があります。`)
};

const hi_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप प्रत्येक शॉट परिवर्तन के लिए थंबनेल जनरेट करवाना चाहेंगे? इसमें अतिरिक्त समय लग सकता है।`)
};

const pt_pt2_scene_change_detection_thumbnail_prompt_text = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja que sejam geradas miniaturas para cada alteração de disparo detectada? Isso pode levar algum tempo adicional.`)
};

/**
* | output |
* | --- |
* | "Would you like thumbnails generated for each detected shot change? This can take additional time." |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_text = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "de") return de_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "it") return it_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "ru") return ru_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "es") return es_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "ja") return ja_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "hi") return hi_scene_change_detection_thumbnail_prompt_text(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_thumbnail_prompt_text(inputs)
	return en_scene_change_detection_thumbnail_prompt_text(inputs)
});